import { useEffect, useState } from "react";
import config from "../../../../../../config";
import Lightbox from "yet-another-react-lightbox";
import Thumbnails from "yet-another-react-lightbox/plugins/thumbnails";
import "yet-another-react-lightbox/styles.css";
import "yet-another-react-lightbox/plugins/captions.css";
import "yet-another-react-lightbox/plugins/thumbnails.css";
import QrCode from "../../../../../../Modal/QrCode";

const ProductsList = ({ order, qcRequestData, status, orderDeliveryType }) => {
  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [images, setImages] = useState([]);
  const [productImage, setProductImage] = useState([]);
  const [productName, setProductName] = useState([]);
  const [senstivityName, setSenstivityName] = useState([]);
  const [packagingType, setPackagingType] = useState("");
  const [variantName, setVariantName] = useState([]);
  const [modifiers, setModifiers] = useState([]);
  const [isQrCodeModalOpen, setIsQrCodeModalOpen] = useState(false);
  const [prepTime, setPrepTime] = useState([]);
  const [barCode, setBarcode] = useState([]);
  const [initiatedText, setInitiatedText] = useState("");

  const showQrCodeModal = () => {
    setIsQrCodeModalOpen(true);
  };
  const handleQrCodeOk = () => {
    setIsQrCodeModalOpen(false);
  };
  const handleQrCodeCancel = () => {
    setIsQrCodeModalOpen(false);
  };

  useEffect(() => {
    // get image
    let allimages = [];
    let variantName = "";
    for (let itm1 of order?.orderItemJson?.productUoms) {
      for (let image of itm1.productUomImages) {
        allimages.push({ src: config.AWS_URL + image.image });
        if (parseInt(image.featured) === 1) {
          setProductImage(image.image);
        }
      }
      for (let local of itm1.productUomLocales) {
        if (local.languageCode === "en") variantName = local.name;
      }
      setPrepTime(itm1.prepTime);
    }
    setImages(allimages);
    setVariantName(variantName);

    // get product name
    for (let itm1 of order?.orderItemJson?.productLocales) {
      if (itm1.languageCode === "en") setProductName(itm1.name);
    }

    // get modifier
    let modifiresData = [];
    for (let row of order?.orderItemJson?.productModifier) {
      let name_en = "";
      let values = [];
      for (let row1 of row?.modifierGroup?.modifierGroupLocales) {
        if (row1.languageCode === "en") name_en = row1.name;
      }
      for (let row1 of row?.productUomModifierItems) {
        if (row1.modifierGroupItem?.modifierGroupItemLocales)
          for (let row2 of row1.modifierGroupItem?.modifierGroupItemLocales) {
            if (row2.languageCode === "en") values.push(row2.name);
          }
      }
      modifiresData.push({
        name_en: name_en,
        values: values.join(","),
      });
    }
    setModifiers(modifiresData);
    
    setSenstivityName(order?.product?.productUoms[0]?.productUomSensitivity?.locales[0]?.name || "");
    const lang = localStorage.getItem("lang") || "en";
    const locales = order?.product?.productUoms?.[0]?.packagingType?.locales || [];
    const packagingTypeName = locales.find(l => l.languageCode === lang)?.name || locales[0]?.name || "";
    setPackagingType(packagingTypeName);

    setBarcode(order.barCode);

    let qcRequestDataText = "";

    for (let item of qcRequestData) {
      if (
        item.orderDetailId === order.id &&
        item.status === "approve" &&
        order.vendorType !== "host"
      )
        qcRequestDataText = "Approved";
    }
    if (qcRequestDataText === "") {
      for (let item of qcRequestData) {
        if (
          item.orderDetailId === order.id &&
          item.status === "reject" &&
          order.vendorType !== "host"
        )
          qcRequestDataText = "Reject";
      }
    }
    if (qcRequestDataText === "" || qcRequestDataText === "Reject") {
      for (let item of qcRequestData) {
        if (
          item.orderDetailId === order.id &&
          item.status === "pending" &&
          order.vendorType !== "host"
        )
          qcRequestDataText = "Request Sent";
      }
    }
    if (qcRequestDataText === "" || qcRequestDataText === "Reject") {
      for (let item of qcRequestData) {
        if (
          item.orderDetailId === order.id &&
          item.status === "in_review" &&
          order.vendorType !== "host"
        )
          qcRequestDataText = "In Review";
      }
    }
    if (
      qcRequestDataText === "" &&
      qcRequestData.length > 0 &&
      order.vendorType !== "host"
    ) {
      qcRequestDataText = "Not Initiated";
    }
    setInitiatedText(qcRequestDataText);
  }, [order, qcRequestData]);

  return (
    <>
      {
        <>
          <div className="flex items-center my-3">
            <div className="basis-[50%] flex">
              <div className="flex flex-col justify-center items-center">
                <img
                  src={config.AWS_URL + productImage}
                  alt=""
                  className="w-[50px] h-[50px] object-cover rounded aspect-square"
                  onClick={() => setLightboxOpen(true)}
                />
                <div
                  className="text-[#808080] underline whitespace-nowrap cursor-pointer"
                  onClick={() => setLightboxOpen(true)}
                >
                  Images
                </div>
              </div>
              <div className="pl-2">
                <h3 className="text-sm font-semibold">
                  {productName} ({variantName})
                </h3>
                <ul>
                  {modifiers?.map((row, rowIndex) => {
                    return (
                      <li key={rowIndex} className="text-gray-200 text-xs">
                        {row.name_en} : {row.values}
                      </li>
                    );
                  })}
                  {packagingType && (
                    <li className="text-gray-200 text-xs">
                      Packaging Type : {packagingType}
                    </li>
                  )}
                  {senstivityName && (
                    <li className="text-gray-200 text-xs">
                      Sensitivity : {senstivityName}
                    </li>
                  )}
                </ul>
              </div>
            </div>
            <Lightbox
              open={lightboxOpen}
              close={() => setLightboxOpen(false)}
              slides={images}
              plugins={[Thumbnails]}
            />
            <div className="basis-[16.66%] ">
              {status !== "placed" &&
              status !== "confirmed" &&
              order?.qrImageLink ? (
                <img
                  src={config.AWS_URL + order?.qrImageLink}
                  alt="QR-code"
                  className="w-[33px] h-[33px] rounded"
                  onClick={showQrCodeModal}
                />
              ) : null}
            </div>
            <div className="basis-[16.66%] flex justify-center">
              {initiatedText === "Approved" ? (
                <span className=" px-[10px] py-[3px] rounded text-sm bg-[#EDFFDF] text-[#2E8900]">
                  {initiatedText}
                </span>
              ) : null}
              {initiatedText === "Reject" ? (
                <span className=" px-[10px] py-[3px] rounded text-sm bg-red-200 text-red-100">
                  {initiatedText}
                </span>
              ) : null}
              {initiatedText === "Request Sent" ? (
                <span className=" px-[10px] py-[3px] rounded text-sm bg-[#F4F6FA] text-[#36618E]">
                  {initiatedText}
                </span>
              ) : null}
              {initiatedText === "Not Initiated" ? (
                <span className=" px-[10px] py-[3px] rounded text-sm bg-[#FFEFD3] text-[#F9BE00]">
                  {initiatedText}
                </span>
              ) : null}
              {initiatedText === "In Review" ? (
                <span className=" px-[10px] py-[3px] rounded text-sm bg-[#F4F6FA] text-[#36618E]">
                  {initiatedText}
                </span>
              ) : null}
            </div>
            {order?.totalAmount > 0 ? (
              <div className="basis-[16.66%] flex justify-end">
                <div className="text-sm font-medium">
                  SAR {order?.totalAmount}
                </div>
              </div>
            ) : null}
          </div>
        </>
      }
      <QrCode
        isOpen={isQrCodeModalOpen}
        onOk={handleQrCodeOk}
        onCancel={handleQrCodeCancel}
        imageSrc={config.AWS_URL + order.qrImageLink}
        barCode={barCode || ""}
      />
    </>
  );
};
export default ProductsList;
